import React from 'react';
import styled, { css } from 'styled-components';
import { theme } from 'utils/style/theme';

/**
 *
 * @returns {검색바와 동일선상에 있는 등록 버튼}
 */

interface IProps {
  children: string;
  backColor?: string;
  textColor?: string;
  name?: string;
  disabled?: boolean;
  modal?: boolean | undefined; // modal 여부에 따라 버튼 배경 색이 달라진다.
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  typename?: 'del' | 'goBack' | string | undefined; // 버튼 백그라운드 컬러 변경을 위한 prop
}
const RegisterButton: React.FC<IProps> = ({
  backColor,
  textColor,
  children,
  onClick,
  disabled,
  name,
  style,
  modal,
  typename,
}) => {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      name={name}
      style={style}
      modal={modal}
      typename={typename}
      backColor={backColor}
      textColor={textColor}
    >
      {children}
    </Button>
  );
};

export default RegisterButton;

const Button = styled.button`
  padding: 0.6rem 1.5rem;

  background-color: ${(props) =>
    props.backColor ? props.backColor : props.theme.colors.primary};

  /* background-color: ${(props) =>
    props.typename === 'del' ? 'gray' : props.theme.colors.primary}; */
  box-shadow: 2px 1.5px 2px 0.2px rgb(0 0 0 / 15%);
  margin-left: 0.8rem;
  color: ${(props) =>
    props.textColor
      ? props.textColor
      : props.disabled
      ? theme.colors.gray_2
      : '#fff'};

  border-radius: 0.3rem;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? `not-allowed` : `pointer`)};
  transition: 0.25s;
  //* TODO: hover 일 때 효과 넣기 */
  &:hover {
    background-color: ${theme.colors.blueText};
    box-shadow: 2px 1.5px 2px 0.2px rgb(0 0 0 / 30%);
    background-position: 100% 0%;
    /* moz-transition: all 0.4s ease-in-out;
    -o-transition: all 0.4s ease-in-out;
    -webkit-transition: all 0.4s ease-in-out; */
    transition: all 0.2s ease-in-out;
  }
  ${(props) =>
    props.typename === 'info' &&
    css`
      background-color: ${theme.colors.blue_04};
      border-radius: 5rem;
    `}
  ${(props) =>
    props.typename === 'goBack' &&
    css`
      background-color: ${theme.colors.table_button};
      color: ${theme.colors.blueText};
      border-radius: 5rem;
    `}
      ${(props) =>
    props.typename === 'search' &&
    css`
      border-radius: 5rem;
      background-color: ${theme.colors.blue_04};
    `}
      ${(props) =>
    props.typename === 'otomeInfo' &&
    css`
      background-color: ${theme.colors.primary};
      border-radius: 5rem;
    `}
`;
